// extracted by mini-css-extract-plugin
export default {"roleContainer":"Role_roleContainer__sB9nv","role":"Role_role__aoMbV"};